import { filter, takeUntil } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { Component, EventEmitter, Input, OnInit, Output, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';

@Component({
  selector: 'calsoft-price-table-plan4',
  templateUrl: './price-table-plan4.component.html',
  styleUrls: ['./price-table-plan4.component.scss']
})
export class PriceTablePlan4Component implements OnInit, OnDestroy {

  sanitizedUrl: string = '';

  url = '';

  priceForm: FormGroup;
  formData:any;
  btntext:string;
  @Output() setData4 = new EventEmitter<any>();
  @Input() priceplandata4: any;
  
  constructor(private fb: FormBuilder, private snackBar: MatSnackBar, private router: Router) {
      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });
 }

  ngOnInit() {
    this.createForm();
    this.populateForm();
//    console.log(this.priceplandata4);
  }

  populateForm() {
    if (this.priceplandata4) {
      const pricedetailFormArray = this.priceForm.get('pricedetail') as FormArray;
  
      // Clear existing controls
      while (pricedetailFormArray.length !== 0) {
        pricedetailFormArray.removeAt(0);
      }
  
      this.priceplandata4.forEach((detail: any) => {
        const detailFormGroup = this.fb.group({
          title: detail.title,
          list_detail: this.fb.array([])
        });
  
        const listDetailFormArray = detailFormGroup.get('list_detail') as FormArray;
  
        detail.list_detail.forEach((item: any) => {
          const listItemFormGroup = this.fb.group(item);
          listDetailFormArray.push(listItemFormGroup);
        });
  
        pricedetailFormArray.push(detailFormGroup);
      });
      this.btntext = 'Update';
    }
  }
  

  createForm() {
    this.priceForm = this.fb.group({
      pricedetail: this.fb.array([])
    });

    // Initialize form with empty values
    this.addPricingDetails();
    this.btntext = 'Submit';
  }

  get pricedetail(): FormArray {
    return this.priceForm.get('pricedetail') as FormArray;
  }

  addPricingDetails() {
    this.pricedetail.push(this.fb.group({
      title: '',
      list_detail: this.fb.array([])
    }));

    // You can initialize with default values if needed
    this.addListDetail(this.pricedetail.length - 1);
  }

  addListDetail(index: number) {
    const listDetail = this.pricedetail.at(index).get('list_detail') as FormArray;
    
    listDetail.push(this.fb.group({
      sub_title: '',
      sub_title1: '',
      sub_title2: '',
      sub_title3: '',
      sub_title4: '',
      sub_title5: '',
      sub_title6: ''
    }));
  }

  deletePricingDetail(index: number) {
    this.pricedetail.removeAt(index);
  }

  deleteListDetail(detailIndex: number, listIndex: number) {
    const listDetail = this.pricedetail.at(detailIndex).get('list_detail') as FormArray;
    listDetail.removeAt(listIndex);
  }

  onSubmit() {
    // Transform form values to match the provided JSON structure
    this.formData = this.priceForm.value.pricedetail.map((detail) => {
      return {
        title: detail.title,
        list_detail: detail.list_detail.map((item) => {
          return {
            sub_title: item.sub_title,
            sub_title1: item.sub_title1,
            sub_title2: item.sub_title2,
            sub_title3: item.sub_title3,
            sub_title4: item.sub_title4,
            sub_title5: item.sub_title5,
            sub_title6: item.sub_title6,
          };
        })
      };
    });
   // this.snackBar.open("Data saved Ok..", '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
    //console.log(this.formData);
    this.emit();
  }

  emit(){
    this.setData4.emit(this.formData)
  }



  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    protected _onDestroy = new Subject<void>();

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}